interface ZodIssue {
  message: string
  path?: (string | number)[]
}

interface ErrorBody {
  error?: unknown
  success?: boolean
}

function zodIssuesToMessage(issues: ZodIssue[]): string {
  return issues
    .map((issue) => {
      const field = issue.path?.filter((p) => typeof p === "string").join(".") ?? ""
      return field ? `${field}: ${issue.message}` : issue.message
    })
    .join(" · ")
}

export async function toApiError(response: Response): Promise<Error> {
  try {
    const body = await response.clone().json() as ErrorBody

    // Plain string error (most route handlers)
    if (typeof body.error === "string") {
      return new Error(body.error, { cause: response })
    }

    // Zod validation error from zValidator (hono) — { success: false, error: { issues: [...] } }
    if (
      body.success === false &&
      body.error !== null &&
      typeof body.error === "object" &&
      "issues" in body.error &&
      Array.isArray((body.error as { issues: unknown }).issues)
    ) {
      const issues = (body.error as { issues: ZodIssue[] }).issues
      const msg = zodIssuesToMessage(issues)
      return new Error(msg || "Datos inválidos", { cause: response })
    }

    return new Error(response.statusText || "Error desconocido", { cause: response })
  } catch {
    return new Error(response.statusText || `Error ${response.status}`, { cause: response })
  }
}
